"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeDocumentModel = _interopRequireDefault(require("../creative-document/CreativeDocumentModel"));

var _AudioCreativeLayer = _interopRequireDefault(require("./AudioCreativeLayer"));

var _CreativeLayer = _interopRequireDefault(require("./CreativeLayer"));

var _GroupCreativeLayer = _interopRequireDefault(require("./GroupCreativeLayer"));

var _ImageCreativeLayer = _interopRequireDefault(require("./ImageCreativeLayer"));

var _ShapeCreativeLayer = _interopRequireDefault(require("./ShapeCreativeLayer"));

var _SVGCreativeLayer = _interopRequireDefault(require("./SVGCreativeLayer"));

var _TextCreativeLayer = _interopRequireDefault(require("./TextCreativeLayer"));

var _VideoCreativeLayer = _interopRequireDefault(require("./VideoCreativeLayer"));

var _isEmptySet = _interopRequireDefault(require("../../utils/object/isEmptySet"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isNotNumber = _interopRequireDefault(require("../../utils/numbers/isNotNumber"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _warn = _interopRequireDefault(require("../../utils/logger/warn"));

var _creative = require("../../constants/creative");

var Creative = /*#__PURE__*/function () {
  /**
   * Creative's background alpha
   */

  /**
   * Creative's background color
   */

  /**
   * creative mode
   */

  /**
   * Creative's frame end
   */

  /**
   * Creative's frame rate
   */

  /**
   * Creative's frame start
   */

  /**
   * Creative's height
   */

  /**
   * Map of creative layers by element ID
   */

  /**
   * List of creative's root element IDs
   */

  /**
   * List of creative's root element IDs
   */

  /**
   * Creative's width
   */
  function Creative() {
    var _this = this;

    var creativeDocumentModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck2["default"])(this, Creative);
    (0, _defineProperty2["default"])(this, "_backgroundAlpha", _creative.DEFAULT_STAGE_ALPHA);
    (0, _defineProperty2["default"])(this, "_backgroundColor", _creative.DEFAULT_STAGE_COLOR);
    (0, _defineProperty2["default"])(this, "_creativeMode", null);
    (0, _defineProperty2["default"])(this, "_frameEnd", 0);
    (0, _defineProperty2["default"])(this, "_frameRate", _creative.PLAYBACK_FRAMES_PER_SECOND);
    (0, _defineProperty2["default"])(this, "_frameStart", 0);
    (0, _defineProperty2["default"])(this, "_height", _creative.DEFAULT_CREATIVE_HEIGHT_PX);
    (0, _defineProperty2["default"])(this, "_layersById", null);
    (0, _defineProperty2["default"])(this, "_numberOfFrames", 0);
    (0, _defineProperty2["default"])(this, "_rootElementIds", null);
    (0, _defineProperty2["default"])(this, "_width", _creative.DEFAULT_CREATIVE_WIDTH_PX);

    // initialize empty creative
    if (!_CreativeDocumentModel["default"].isCreativeDocumentModel(creativeDocumentModel)) {
      this._rootElementIds = new Set();
      this._layersById = new Map();
      return;
    }

    var creativeDocumentContent = creativeDocumentModel.content,
        creativeMode = creativeDocumentModel.creativeMode,
        creativeDocumentElement = creativeDocumentModel.elements,
        frameRate = creativeDocumentModel.frameRate,
        masks = creativeDocumentModel.masks,
        creativeDocumentMedia = creativeDocumentModel.media,
        rootElementIds = creativeDocumentModel.rootElementIds;
    var rootMask = masks.get('root');

    if ((0, _isNotNumber["default"])(rootMask.height) || (0, _isNotNumber["default"])(rootMask.width)) {
      throw new Error('Invalid Creative dimensions.');
    }

    this._creativeMode = creativeMode;
    this._backgroundAlpha = (0, _isNumber["default"])(rootMask.alpha) ? rootMask.alpha : _creative.DEFAULT_STAGE_ALPHA;
    this._backgroundColor = rootMask.color;
    this._frameEnd = rootMask.frameEnd;
    this._frameRate = frameRate;
    this._frameStart = rootMask.frameStart;
    this._height = rootMask.height;
    this._layersById = new Map();
    this._numberOfFrames = rootMask.frameEnd - rootMask.frameStart + 1;
    this._rootElementIds = rootElementIds;
    this._width = rootMask.width; // set up layers

    creativeDocumentElement.forEach(function (element, elementId) {
      var content = creativeDocumentContent.get(element.contentId); // Unsure how we get an element with not content, but it could happen
      // depending on when state updates occur and how layers are created

      if ((0, _isNil["default"])(content)) return; // Media can be null (groups)

      var media = creativeDocumentMedia.get(content.mediaId); // todo(chuti) creativeNumberOfFrames don't seem like they belong to CreativeLayer

      var creativeLayer = Creative.getCreativeLayerFromCreativeDocument(element, content, media);
      creativeLayer.creativeNumberOfFrames = _this._numberOfFrames;
      creativeLayer.creativeFrameRate = _this._frameRate;

      _this._layersById.set(elementId, creativeLayer);
    }); // set reference to parent layer.

    this._layersById.forEach(function (currentLayer, key, map) {
      /*
         TODO `groupId` is only set in the client and not necessarily in the automatic snap creator
           double check this will work in  all cases.
           maybe use `parentContentId` instead
       */
      var groupId = currentLayer.element.groupId; // set reference to parent layer
      // This is important for things like transform and visibility on canvas

      if ((0, _isNotNil["default"])(groupId)) {
        var parentLayer = map.get(groupId);

        if (_GroupCreativeLayer["default"].isGroupCreativeLayer(parentLayer)) {
          currentLayer.parent = parentLayer;
        } else {// todo() throw error
        }
      } // set reference to children layers for group layers


      if (_GroupCreativeLayer["default"].isGroupCreativeLayer(currentLayer)) {
        var children = currentLayer.content.contentElementIds.map(function (elementId) {
          return _this._layersById.get(elementId);
        }).filter(function (element) {
          // todo: throw error, think of better way to handle error/warnings and logging
          if ((0, _isNil["default"])(element)) {
            // todo: log in sentry
            (0, _warn["default"])('Filtering out an undefined layer for currentLayer', currentLayer);
          }

          return (0, _isNotNil["default"])(element);
        });
        currentLayer.children = new Set(children);
      }
    });
  }

  (0, _createClass2["default"])(Creative, [{
    key: "addLayer",
    value: function addLayer() {
      throw new Error('addLayer has not yet been implemented');
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._rootElementIds.size === 0;
    }
    /**
     * Checks if object is an instance of Creative
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "backgroundAlpha",
    get: function get() {
      return this._backgroundAlpha;
    },
    set: function set(value) {
      this._backgroundAlpha = value;
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this._backgroundColor;
    },
    set: function set(value) {
      this._backgroundColor = value;
    }
  }, {
    key: "creativeMode",
    get: function get() {
      return this._creativeMode;
    },
    set: function set(value) {
      this._creativeMode = value;
    }
  }, {
    key: "frameEnd",
    get: function get() {
      return this._frameEnd;
    }
  }, {
    key: "frameRate",
    get: function get() {
      return this._frameRate;
    }
  }, {
    key: "frameStart",
    get: function get() {
      return this._frameStart;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "layersById",
    get: function get() {
      return this._layersById;
    }
  }, {
    key: "numberOfFrames",
    get: function get() {
      return this._numberOfFrames;
    }
  }, {
    key: "rootElementIds",
    get: function get() {
      return this._rootElementIds;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
  }], [{
    key: "isCreative",
    value: function isCreative(inputObject) {
      return inputObject instanceof Creative;
    }
    /**
     * get Creative from Creative Document JSON
     *
     * @param inJSON
     * @returns {Creative}
     */

  }, {
    key: "fromCreativeDocumentJSON",
    value: function fromCreativeDocumentJSON(inJSON) {
      var creativeDocumentModel = _CreativeDocumentModel["default"].fromJSON(inJSON);

      return new Creative(creativeDocumentModel);
    }
    /**
     * Generate CreativeLayer from Creative Document Element, Content, and Media
     *
     * @param element
     * @param content
     * @param media
     * @returns {CreativeLayer}
     */

  }, {
    key: "getCreativeLayerFromCreativeDocument",
    value: function getCreativeLayerFromCreativeDocument(element, content, media) {
      switch (content.contentType) {
        case _creative.CONTENT_TYPE.AUDIO:
          return new _AudioCreativeLayer["default"](element, content, media);

        case _creative.CONTENT_TYPE.ELEMENT_GROUP:
        case _creative.CONTENT_TYPE.ELEMENT_EFFECT_GROUP:
          return new _GroupCreativeLayer["default"](element, content);

        case _creative.CONTENT_TYPE.IMAGE:
          return new _ImageCreativeLayer["default"](element, content, media);

        case _creative.CONTENT_TYPE.SHAPE:
          return new _ShapeCreativeLayer["default"](element, content, media);

        case _creative.CONTENT_TYPE.SVG:
          return new _SVGCreativeLayer["default"](element, content, media);

        case _creative.CONTENT_TYPE.TEXT:
          return new _TextCreativeLayer["default"](element, content, media);

        case _creative.CONTENT_TYPE.VIDEO:
          return new _VideoCreativeLayer["default"](element, content, media);

        default:
          throw new Error('Unsupported content type');
      }
    }
    /**
     * Given a Creative, return a set of creative layers based on the provided type
     *
     * @param creative
     * @param type
     * @returns {Set<CreativeLayer>}
     */

  }, {
    key: "getCreativeLayersByType",
    value: function getCreativeLayersByType(creative) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _CreativeLayer["default"];

      if (!Creative.isCreative(creative)) {
        throw new Error('Must provide creative of type Creative');
      }

      var creativeLayers = new Set();
      creative.layersById.forEach(function (currentLayer) {
        if (!(currentLayer instanceof type)) return;
        creativeLayers.add(currentLayer);
      });
      return creativeLayers;
    }
    /**
     * Get descendants of a given creative layer
     *
     * @param creative
     * @param creativeLayer
     * @returns {Set<CreativeLayer>}
     */

  }, {
    key: "getLayerDescendants",
    value: function getLayerDescendants(creative, creativeLayer) {
      if (!Creative.isCreative(creative)) {
        throw new Error('Must provide a Creative');
      }

      if (!_CreativeLayer["default"].isCreativeLayer(creativeLayer)) {
        throw new Error('Must provide a CreativeLayer');
      }

      if (!creative.layersById.has(creativeLayer.elementId)) {
        throw new Error("Creative Layer does not exist in this Creative, ".concat(creativeLayer.elementId));
      }

      var descendants = new Set();
      var children = creativeLayer.children;
      if ((0, _isEmptySet["default"])(children)) return descendants; // if has children then check each children's children

      children.forEach(function (childLayer) {
        var descendantsOfChild = Creative.getLayerDescendants(creative, childLayer);
        descendants = new Set([].concat((0, _toConsumableArray2["default"])(descendants), [childLayer], (0, _toConsumableArray2["default"])(descendantsOfChild)));
      });
      return descendants;
    }
  }, {
    key: "getOrderedCreativeLayersByType",
    value: function getOrderedCreativeLayersByType(creative) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _CreativeLayer["default"];

      if (!Creative.isCreative(creative)) {
        throw new Error('Must provide creative of type Creative');
      }

      var orderedCreativeLayers = new Set();
      var rootElementIds = creative.rootElementIds; // set up flattened structure for element Ids

      rootElementIds.forEach(function (elementId) {
        var creativeLayer = creative.layersById.get(elementId);

        if (creativeLayer instanceof type) {
          orderedCreativeLayers.add(creativeLayer);
        }

        if (!_GroupCreativeLayer["default"].isGroupCreativeLayer(creativeLayer)) return;
        var descendants = Creative.getLayerDescendants(creative, creativeLayer);
        descendants.forEach(function (descendantCreativeLayer) {
          if (descendantCreativeLayer instanceof type) {
            orderedCreativeLayers.add(descendantCreativeLayer);
          }
        });
      });
      return orderedCreativeLayers;
    }
  }]);
  return Creative;
}();

exports["default"] = Creative;